import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-suporte-component",
  templateUrl: "./suporte-component.component.html",
  styleUrls: ["./suporte-component.component.scss"],
})
export class SuporteComponentComponent implements OnInit {
  boardList = [
    "- Disque Saúde 136",
    "- Internet",
    "- Carta;",
    "SRTVN Quadra 701 – Via W5 Norte, Lote D, Ed. PO700, 4º andar – CEP: 70.719-040 - Brasília/DF.",
    "- Atendimento presencial;",
    "Esplanada dos Ministérios - Bloco G - Térreo - Edifício Sede – CEP: 10.058-900 - Brasília/DF",
    "Horário de funcionamento: de segunda a sexta-feira, das 9h às 13h e das 14h às 17h",
  ];
  constructor() { }

  ngOnInit() { }

  nav() {
    window.open(
      "https://webatendimento.saude.gov.br/faq/susdigitalprofissional",
      "_blank"
    );
  }
}
